import { render, staticRenderFns } from "./SfHeader.vue?vue&type=template&id=335aea87"
import script from "./SfHeader.vue?vue&type=script&lang=js"
export * from "./SfHeader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfHeader.vue?vue&type=style&index=0&id=335aea87&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "1a8fa0a6"
  
)

export default component.exports